<vue-page-header
  appName="{{ 'title.applicationName' | translate | async }}"
  pageTitle="{{ 'title.recentActivity' | translate | async }}"
  navSection="{{ 'title.appointmentManagement' | translate | async }}"
>
  <app-filter-container>
    <app-appointments-recent-activity-filters></app-appointments-recent-activity-filters>
  </app-filter-container>
</vue-page-header>
<app-page-body>
  <vue-section>
    <app-appointments-recent-activity-table></app-appointments-recent-activity-table>
  </vue-section>
</app-page-body>
